module.exports = __webpack_public_path__ + "static/pymitv_hero-d7c53635f4bebd99ddddade6cf85416c.jpg";